import { Col, Row } from "antd";
import moment from "moment";
import React from "react";
import { Link } from "react-router-dom";
import { EMAIL, GITHUB, LINKEDIN, TWITTER } from "../App.constant";
import Victor from "../assets/images/Victor.svg";
import GithubSVG from "../assets/images/github.svg";
import LinkedinSVG from "../assets/images/linkedin.svg";
import TwitterSVG from "../assets/images/twitter.svg";
import stateWrapper from "../containers/provider";
import { useResponsive } from "../hooks/responsive";

const FooterBar = (props) => {
  const [
    isTabletOrMobileDevice,
    isTabletOrMobile,
    isBigScreen,
    isDesktopOrLaptop,
    isPortrait,
    isRetina,
    isTablet,
  ] = useResponsive();
  const year = moment().format("YYYY");
  return (
    <>
      <div className="footer">
        <div
          style={{
            width: "80%",
            height: "80%",
            padding: 20,
            margin: 40,
            marginTop: 50,
          }}
        >
          <div style={{ marginTop: 40 }}>
            <img src={Victor} style={{ width: 40, height: 40 }} />
          </div>
          <div style={{ marginTop: 20, marginBottom: 30 }}>
            <div
              style={{
                fontSize: 12,
                fontFamily: "Permanent Marker, cursive",
                color: "gray",
              }}
            >
              @{year} Victor Umesiobi
            </div>
          </div>
          <div style={{ marginTop: 20 }}>
            <Row>
              <Col span={12}>
                <div
                  style={{
                    fontSize: 12,
                    fontFamily: "Baloo 2, cursive",
                    color: "#FFFFFF",
                    fontWeight: "bold",
                  }}
                >
                  SITE MAP
                </div>
                <div style={{ marginTop: 20 }}>
                  <div
                    style={{
                      fontSize: 12,
                      fontFamily: "Baloo 2, cursive",
                      color: "#FFFFFF",
                      fontWeight: "lighter",
                      margin: 10,
                    }}
                  >
                    <Link to="/about" style={{ color: "#FFFFFF" }}>
                      About Me
                    </Link>
                  </div>
                  <div
                    style={{
                      fontSize: 12,
                      fontFamily: "Baloo 2, cursive",
                      color: "#FFFFFF",
                      fontWeight: "lighter",
                      margin: 10,
                    }}
                  >
                    <Link to="/contact" style={{ color: "#FFFFFF" }}>
                      Contact Me
                    </Link>
                  </div>
                  <div
                    style={{
                      fontSize: 12,
                      fontFamily: "Baloo 2, cursive",
                      color: "#FFFFFF",
                      fontWeight: "lighter",
                      margin: 10,
                    }}
                  >
                    <Link to="/" style={{ color: "#FFFFFF" }}>
                      Home
                    </Link>
                  </div>
                </div>
              </Col>
              <Col span={12}>
                <Row align="middle">
                  <Col span={12}></Col>
                  <Col span={12}>
                    <div
                      style={{
                        fontSize: 12,
                        fontFamily: "Baloo 2, cursive",
                        color: "#FFFFFF",
                        fontWeight: "bold",
                      }}
                    >
                      GET IN TOUCH
                    </div>
                    <div style={{ marginTop: 20 }}>
                      <div>
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          href={`mailto:${EMAIL}`}
                        >
                          <span
                            style={{
                              color: "#FFFFFF",
                              fontSize: 12,
                              fontWeight: "400",
                              fontFamily: "Baloo 2, cursive",
                            }}
                          >
                            {EMAIL}
                          </span>
                        </a>
                      </div>
                      <div style={{ marginTop: 20 }}>
                        <Row>
                          <Col span={8}>
                            <div
                              className="glass-light"
                              style={{
                                borderRadius: 10,
                                width: 30,
                                height: 30,
                              }}
                            >
                              <center style={{ marginTop: 10 }}>
                                <a
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  href={LINKEDIN}
                                >
                                  <img
                                    src={LinkedinSVG}
                                    style={{ width: 15, height: 15 }}
                                  />
                                </a>
                              </center>
                            </div>
                          </Col>
                          <Col span={8}>
                            <div
                              className="glass-light"
                              style={{
                                borderRadius: 10,
                                width: 30,
                                height: 30,
                              }}
                            >
                              <center style={{ marginTop: 10 }}>
                                <a
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  href={GITHUB}
                                >
                                  <img
                                    src={GithubSVG}
                                    style={{ width: 15, height: 15 }}
                                  />
                                </a>
                              </center>
                            </div>
                          </Col>
                          <Col span={8}>
                            <div
                              className="glass-light"
                              style={{
                                borderRadius: 10,
                                width: 30,
                                height: 30,
                              }}
                            >
                              <center style={{ marginTop: 10 }}>
                                <a
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  href={TWITTER}
                                >
                                  <img
                                    src={TwitterSVG}
                                    style={{ width: 15, height: 15 }}
                                  />
                                </a>
                              </center>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </>
  );
};

export default stateWrapper(FooterBar);
